<template>
  <transition name="bbp-slide-fade">
    <div
      v-if="currentList.length"
      class="bbp-requests-accordion"
      :class="{'bbp-requests-accordion_open': openTable}"
    >
      <button class="bbp-requests-accordion__button"
              :class="{'bbp-requests-accordion__button_active': openTable}"
              @click="setOpenTable">
        +{{currentList.length}} {{statusName}} REQUESTS
      </button>
      <transition name="bbp-fade">
        <div class="bbp-requests-accordion__table" v-if="openTable">
          <BBPTable :columns="columns"
                    :rows="currentList"
                    :no-data-text="noDataText"
                    :limit="defLimit"
                    :page="currentPage"
                    :no-data="noData"/>
          <BBPPagination v-show="currentList.length > 0"
                         :data="fullInfo"
                         :getQuery="getRequests"
                         :limit="defLimit"
                         :sticky="true"
                         class="bbp-pagination"/>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import RequestApi from '@/api/Requests/api'
import requestsStatuses, {DELAYED} from '@/constants/requestStatuses'
import {find, get, filter, cloneDeep} from 'lodash'
import listOfRequestsColumns from '@/constants/TablesSettings/listOfRequestsColumns'
import BBPTable from '@/components/Main/BBPTable/BBPTable'
import BBPPagination from '@/components/Main/BBPPagination/BBPPagination'
import { BC_REQUEST_TAB_ID } from '@/constants/tabs/requestsTabs'

export default {
  name: 'ListOfRequestWithStatus',
  props: ['status', 'activeTab'],
  components: {
    BBPTable,
    BBPPagination
  },
  data () {
    return {
      openTable: false,
      fullInfo: {},
      currentPage: 1,
      defLimit: 25,
      noData: false,
      noDataText: 'Sorry, no requests found.'
    }
  },
  computed: {
    mainScroll () {
      return this.$store.getters.mainScroll
    },
    columns () {
      const columns = cloneDeep(listOfRequestsColumns)
      const noMenu = filter(columns, (col) => col.type !== 'menu')
      noMenu.forEach((el) => {
        if (el.isNoClick !== undefined) el.isNoClick = true
      })
      return noMenu
    },
    statusName () {
      const status = find(requestsStatuses, {id: this.status})
      return get(status, 'title', '')
    },
    currentList: {
      get () {
        const isDeclined = this.status === DELAYED.id
        return isDeclined ? this.requestsListDeclined : this.requestsListForward
      },
      set (data) {
        const isDeclined = this.status === DELAYED.id
        isDeclined ? this.requestsListDeclined = data : this.requestsListForward = data
      }
    },
    requestsListDeclined: {
      get () {
        return this.$store.getters.requestsListDeclined
      },
      set (data) {
        this.$store.dispatch('setRequestsListDeclined', data)
      }
    },
    requestsListForward: {
      get () {
        return this.$store.getters.requestsListForward
      },
      set (data) {
        this.$store.dispatch('setRequestsListForward', data)
      }
    }
  },
  methods: {
    updateColumns () {
      const manager = this.columns.find((el) => el.isType)
      const isBC = this.activeTab === BC_REQUEST_TAB_ID
      manager.title = isBC ? 'BC' : 'PM'
      manager.display = `${isBC ? 'businessConsultant' : 'projectManager'}.image.path`
      manager.popup = `${isBC ? 'businessConsultant' : 'projectManager'}.username`
      manager.prop = isBC ? 'businessConsultant' : 'projectManager'
    },
    setOpenTable () {
      this.openTable = !this.openTable
      if (this.openTable) {
        this.$nextTick(this.scrollDown)
      }
    },
    scrollDown () {
      const mainScroll = get(this.mainScroll, 'target', {})
      mainScroll.scrollTop += 156
      const scrollElem = document.scrollingElement
      scrollElem.scrollTop += 156
    },
    getRequests ({page}) {
      this.currentPage = page || this.currentPage
      const query = {
        limit: this.defLimit,
        page: this.currentPage,
        sort: 'dateStart&sort[]=-1',
        status: this.status,
        requestType: this.activeTab
      }
      RequestApi.getRequests(query)
        .then(({data}) => {
          const { totalDocs = 0, requests = [] } = data
          this.noData = !totalDocs
          this.fullInfo = data
          this.currentList = requests
        })
        .catch(err => {
          this.noData = true
          console.error(err)
        })
    }
  },
  watch: {
    activeTab () {
      this.updateColumns()
      this.getRequests({})
    }
  },
  beforeMount () {
    this.updateColumns()
    this.getRequests({})
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-requests-accordion {
    @include global-font;
    max-height: 38px;
    transition: 0.5s;

    &:last-child {
      margin-bottom: 50px;
    }

    &_open {
      max-height: 100vh
    }

    &__button {
      padding: 10px 15px;
      border: 1px solid $color-accent;
      box-sizing: border-box;
      border-radius: 5px;
      color: $color-accent;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
      text-transform: uppercase;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        border-color: $color-accent-hover;
        color: $color-accent-hover;
      }
    }

    &__table {
      margin-top: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Requests/ListOfRequests/ListOfRequestWithStatus.vue